import { create } from 'zustand'
import type { WatchlistItem } from '../types'

interface WatchlistState {
  items: WatchlistItem[];
  isLoading: boolean;
  setItems: (items: WatchlistItem[]) => void;
  addItem: (item: WatchlistItem) => void;
  removeItem: (id: string) => void;
  updateItem: (id: string, data: Partial<WatchlistItem>) => void;
  setLoading: (loading: boolean) => void;
}

export const useWatchlistStore = create<WatchlistState>((set) => ({
  items: [],
  isLoading: false,

  setItems: (items) => set({ items }),

  addItem: (item) => set((state) => ({
    items: [...state.items, item]
  })),

  removeItem: (id) => set((state) => ({
    items: state.items.filter(item => item.id !== id)
  })),

  updateItem: (id, data) => set((state) => ({
    items: state.items.map(item =>
      item.id === id ? { ...item, ...data } : item
    )
  })),

  setLoading: (isLoading) => set({ isLoading }),
}))
